module.exports = __webpack_public_path__ + "media/unlock-reward.8fb75c98.mp3";